import React, { useState,useEffect  } from 'react';
// import uuidv4 from 'uuid/dist/v4';
import { v4 as uuidv4 } from 'uuid';  // see https://stackoverflow.com/questions/62549457/error-err-package-path-not-exported-package-subpath-v4-is-not-defined-by
import './App.css';
import {OYMData} from './OYMData.js';
import MonthlyMeetingList from './MonthlyMeetingList';
import FriendList from './FriendList';
import {peek,committeeOYMList,friendList,screenType,Breadcrumb,sessionStatusStates,toggleWaitingForEmailVerification,mandOElement,searchElement} from './myFunctions.js';
import BreadcrumbIndexList from './BreadcrumbIndexList';
import BreadcrumbIndexEntry from './BreadcrumbIndexEntry';
import CommitteeList from './CommitteeList';
import ServiceMandO from './ServiceMandO';
import FriendPaged from './FriendPaged';
import OhioYearlyMeeting from './OhioYearlyMeeting';
import ChangePassword from './ChangePassword';
import Signon from './Signon';
import { getAuth,signOut, connectAuthEmulator ,onAuthStateChanged} from "firebase/auth";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import oymjson from "./OYMData.json";
// import {dataToShare} from './PracticeConditionalShare.js';
/* Version 0.4 02/19/2022 fix onAuthStateChanged hook bug.  See 2/19/2022 in journal
   Version 0.5 03/01/2022 update data (previous data from wrong year)
   version 0.6 03/12/2022 update data after fixes in parser (bad parsing of telephone number affected address)
   version 0.7 03/13/2022 A number of references  to Friends that did not have buttons were given such.
                          This included: Clerks of Quarters (on home page), household members (in FriendView), committee 
                          members (when committee invoked from FriendView), Clerk of Committees and Monthly Meetings.
   version 0.8 03/19/2022 Correct spelling and change wording on signon page.
   version 0.9 03/24/2022 OYM Icon and name in title.
   version 0.A 03/25/2022 More icon/png changes (to manifest.json).
   version 1.0 03/25/2022 Regenerated to update for production (also removed Niranjan Nath Kaul).
   version 2.0 01/28/2023 Major changes to move oym data object from hard code to cloud storage.
   version 2.1 05/15/2023 Add Ministry and Oversite
   version 2.1.1 10/21/2023 Fix bug where offices do not display.
   version 2.2 10/26/2023 Add search
   version 2.2.1 11/03/2023 Fix bug where member of household with personal phone number used household number.
   version 2.2.1 11/21/2022 Fix bugs with meeting description.   \n replaced with <br>
*/
const OYMONLINE_VERSION={
  versionNumber:  "2.2.2",
  production:true
}
console.log("Version:"+OYMONLINE_VERSION); 
function displayVerion(e){
  let versionMessage = "Ohio Yearly Meeting Online.\n\tVersion "+OYMONLINE_VERSION.versionNumber;
  if (OYMONLINE_VERSION.production){
    versionMessage+="\n\tProduction mode.";
  } else {
    versionMessage+="\n\tTest mode.  Not compatable with internet usage";
  }
  alert(versionMessage);
  console.log(versionMessage);
}
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCEWHjrmdUoiBcATcLuWg_IudAPzXGuagc",
  authDomain: "practice-64422.firebaseapp.com",
  projectId: "practice-64422",
  storageBucket: "practice-64422.appspot.com",
  messagingSenderId: "884775914616",
  appId: "1:884775914616:web:6ce07be01fa27ff2c1f18d",
  // measurementId: "G-J7FW4ZC54V" (practice version)
  measurementId: "G-7DC8L381TM"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
let auth = getAuth();
if (!OYMONLINE_VERSION.production)
{
  connectAuthEmulator(auth, "http://localhost:9099");
  console.log("Authentication emulator connected");
}

// End Initialize Firebase

const timeConstructed=new Date();
const AppObjectId=timeConstructed.getHours() + ":" + timeConstructed.getMinutes() + ":" + timeConstructed.getSeconds()+timeConstructed.getMilliseconds();
let AppMethodInvocation=0;
  console.log("OYMData precheckpoint");

function App() {
  ++AppMethodInvocation;
  function myLog(logMessage){
    console.log(AppObjectId+"-"+AppMethodInvocation+"-"+logMessage);
  }
  auth = getAuth();
  let user=auth.currentUser;
  let authenticated=false;   // convience variable to check authentication.  Note, is not persistant accross renders.
// Start Session Status initialization
  myLog("App() starting");
  console.log("Starting App user:",auth.currentUser);
  const [sessionStatus,setStatus] = useState (sessionStatusStates.notAuthenticated);
  myLog("Starting App with session status:"+sessionStatus);

  if (user!==null){
    console.log("user exists");
    if (user.emailVerified){
      if (sessionStatus===sessionStatusStates.notAuthenticated) {
          console.log("Existing user not signed in");
      } else if (sessionStatus!==sessionStatusStates.authenticated){
          console.log("setting status to authenticated");
          setSessionStatus(sessionStatusStates.authenticated);
      } else {
        console.log("Session status not changing from "+sessionStatus);
      }
    } else {
      console.log("Illogic condition.  User exists but not email verified.");
    }
  } else {
    console.log("User object not available.  Not signed on.");
  }
// End Session Status initialization
// Start OYM object and authorization switch management.
  function constructOym(isDataPublic){
    console.log("Initialiing public oym.   Should only happen once for each public and private objects.  isDataPublic:"+isDataPublic);
    return new OYMData(isDataPublic);
  }

  /* We must have both a public and private OYM object, since there is a possiblity that 
    requests for both public and private data be outstanding and/or satisfied at the same time.
    
  */

  const [publicOYM,setPublicOYM] = useState(()=>constructOym(false));  //  https://stackoverflow.com/questions/57525059/why-is-usestate-hook-calling-initialising-value-code-twice
  const [privateOYM,setPrivateOYM] = useState(()=>constructOym(true));  //  https://stackoverflow.com/questions/57525059/why-is-usestate-hook-calling-initialising-value-code-twice
  let oym=publicOYM;

  // Start a little sideshow: Resetting after signon or bringing up home page when authorization left over from previous session(authenticatedByStateChange).
  //     To bring up home page, breadcrumbs must be defined and potentally reset.
  //     Then status checked to see if reset must be performed.
  
  const signonCrumb = {
    name:"Signon",
    component: (<Signon oym={activeOYM()} status={sessionStatus} setSessionStatus={setSessionStatus}/>),
    key: uuidv4()
  }
  const [breadcrumbs,setCrumbs]= useState([signonCrumb]);
  console.log("After useState base crumb is "+peek(breadcrumbs).name,breadcrumbs);

  if (sessionStatus===sessionStatusStates.signonCompleted||sessionStatus===sessionStatusStates.authenticatedByStateChange){
    authenticated=true;  // kludge.  
    resetBreadcrumbsToOhioYearlyMeeting();  // will change useState variable but should not loop
  } else if (sessionStatus===sessionStatusStates.signoutCompleted){
    resetBreadcrumbsToSignon();
    setSessionStatus(sessionStatusStates.notAuthenticated);
  }
  // end a little sideshow
  // continue managing object and authentication switch.
  if (sessionStatus===sessionStatusStates.authenticated){
    authenticated=true;
    console.log("Starting: set oym to private");
    oym=privateOYM;
  } else {
    authenticated=false;
    console.log("session status not authenticated");
  }
  console.log("Start oym is",oym);
  console.log("authenticated:"+authenticated);
  // End managing object and authentication switch.
  // Start defining friendSignedOn that may be used for display.
  let friendSignedOn=null;
  if (oym.isDataPrivate){
    friendSignedOn=oym.isEmail(user.email);
    if (friendSignedOn===null){
      console.log(user.email+" not found. PrivateData:"+oym.isDataPrivate,oym)
    }  
  }
  // end Start defining friendSignedOn 
    // Start managing Search item
  /*  searchItem is used in the Search component and is
      defined there with a useState, and updated .  However re-rendering
      the last search item is saved in the base App component
      so that it will not be lost when breadcrumb is invoked. 

      Breadcrumbs appear to save references to previous search items,
      so each time a search item is set, we reset breadcrumbs to contain only 
      the search item.
  */
      const [searchItem,setSearchItemInApp] = useState ("");
      console.log("SearchItem at useState:"+searchItem);
      // getSearchItem is deprecated. 
      function getSearchItem(){
        console.log(AppObjectId+"-"+AppMethodInvocation+"-SearchItem at get:"+searchItem);
        // myLog("SearchItem at get:"+searchItem);
        return searchItem;
      }
      function setSearchItem(searchItem){
        console.log("about to set search item in app to "+searchItem);
        setSearchItemInApp(searchItem);
        console.log("Set search item in app to "+searchItem+". But will we ever see this message?");
        console.log("about to reset bredcrumbs to search "+":"+searchItem);
        resetBreadcrumbsToSearchWithItem(searchItem);
        console.log("reset bredcrumbs to search:"+searchItem);
      }
  // End managing Search item

  function activeOYM(){
    // if (sessionStatus===sessionStatusStates.authenticated){
    if (authenticated){
      console.log("ActiveOYM returned private",sessionStatus,authenticated);
      return privateOYM;
    }
    console.log("ActiveOYM returned public",sessionStatus,authenticated);
    return publicOYM

  }
  function doneLoading(loadedOYM){
    myLog("App has recognized loading completed for "+loadedOYM.fileToLoad+"-"+loadedOYM.oymId());
    console.log("Object returned from load.",loadedOYM);
    console.log("Existing object.",oym.oymId(),oym);
    
    if (loadedOYM.isDataPrivate){
      console.log("Private Data loaded.  Will set oym to private");
      setPrivateOYM(loadedOYM);
      authenticated=true;
      oym=loadedOYM;
    } else {
      setPublicOYM(loadedOYM);
      if (oym.data!=null&&!oym.data.isDataPrivate){
        console.log("Public Data loaded.  Will set oym to public");
        oym=loadedOYM;
      } else {
        console.log("Public Data loaded, but oym already private.  Will not overlay.");
      }
    }
  }

  console.log("checkpoint #7.0 OYMid:",oym);
  function dropBreadcrumb(breadcrumb){
    setCrumbs(prevBreadcrumbs => {
        let returnBreadcrumbs =[...prevBreadcrumbs,breadcrumb];
        return returnBreadcrumbs;
    });
    console.log(breadcrumbs);
  }
  // This was a futle attempt to kludge a problem.   When problem is solved should delete.
  function searchCustomDropBreadcrumb(breadcrumb){
    console.log("Custom search drop breadcrumb");
    breadcrumbs=[new Breadcrumb("Search",searchElement(oym.data.friends[1],oym,searchItem,setSearchItem, dropBreadcrumb))];
    dropBreadcrumb(breadcrumb);
  }
  function pickupBreadcrumbs(key){
    myLog("SetCrumbs start");
    setCrumbs(prevBreadcrumbs => {
        let foundBreadcrumb = prevBreadcrumbs.find(breadcrumb=> breadcrumb.key==key);
        let startRemoveIndex=prevBreadcrumbs.indexOf(foundBreadcrumb)+1;
        return prevBreadcrumbs.slice(0,startRemoveIndex);
    })
    myLog("SetCrumbs end");
  }

 function resetBreadcrumbsTo(initialBreadCrumb){
    myLog("Resetting breadcrumbs from "+peek(breadcrumbs).name+" to "+initialBreadCrumb.name);
    setCrumbs(()=> [initialBreadCrumb]);
    myLog("After call to setCrumbs, base crumb is  "+peek(breadcrumbs).name);
   }
  function resetBreadcrumbsToFriendList(e){
    resetBreadcrumbsTo(new Breadcrumb("Members List",friendList(oym.data.friends[1],oym,dropBreadcrumb)));
  }
  function resetBreadcrumbsToFriendPaged(e){
    resetBreadcrumbsTo(new Breadcrumb("Members List Paged",(<FriendPaged key={uuidv4()} list={oym.data.friends[1]} oym={oym} dropBreadcrumb={dropBreadcrumb}/>)));
  }
  function resetBreadcrumbsToSearch(e){
    // console.log("Resetting Breadcrumbs to Search:"+getSearchItem());
    resetBreadcrumbsTo(new Breadcrumb("Search",searchElement(oym.data.friends[1],oym,searchItem,setSearchItem, dropBreadcrumb)));    
  }
  function resetBreadcrumbsToSearchWithItem(searchItemToSet){
    console.log("Resetting Breadcrumbs to Search:"+searchItemToSet);
    resetBreadcrumbsTo(new Breadcrumb("Search",searchElement(oym.data.friends[1],oym,searchItemToSet,setSearchItem, dropBreadcrumb)));    
  }  
  function resetBreadcrumbsToMeetingList(e){
    console.log("resetBreadcrumbsToMeetingList authenticated "+authenticated);
    resetBreadcrumbsTo(new Breadcrumb("Monthly Meetings",(    <>
      <center>
      <MonthlyMeetingList  key={uuidv4()} list={oym.data.montlyMeetings[1]} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
      </center>
      </>)));
  }
  function resetBreadcrumbsToCommitteeList(e){
    resetBreadcrumbsTo(new Breadcrumb("Committees",committeeOYMList(oym.data.committees[1],oym,dropBreadcrumb,authenticated)));
  }
  function resetBredcrumbsToMandO(e){
    resetBreadcrumbsTo(new Breadcrumb("Ministry & Oversight",mandOElement(oym,dropBreadcrumb,authenticated)));
  }

  function resetBreadcrumbsToOhioYearlyMeeting(e){
    console.log("Resetting BreadcrumbsToOhioYearlyMeeting",activeOYM());
    resetBreadcrumbsTo(new Breadcrumb("Home",(<OhioYearlyMeeting key={uuidv4} oym={activeOYM()} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>)));
    console.log("Breadcrumbs already set To OhioYearlyMeeting",oym,activeOYM());
  }

  function resetBreadcrumbsToSignon(e){
    console.log("in resetBreadcrumbsToSignon:"+authenticated);
    resetBreadcrumbsTo(new Breadcrumb("Signon",(<Signon oym={oym} status={sessionStatus} setSessionStatus={setSessionStatus}/>)));
  }
  function resetBreadcrumbsToPasswordChange(e){
    console.log("for pw change:",resetBreadcrumbsToOhioYearlyMeeting);
    resetBreadcrumbsTo(new Breadcrumb("Change Password",(<ChangePassword goHome={resetBreadcrumbsToOhioYearlyMeeting} />)));
  }
  console.log("User checkpoint #1 ",auth.currentUser);

const oymCrumb = new Breadcrumb("Home",(<OhioYearlyMeeting key={uuidv4} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>));

console.log("User checkpoint #2 ",auth.currentUser);

function setSessionStatus(sessionStatusPassed){
    myLog("Setting session status from "+sessionStatus+" to "+sessionStatusPassed);
    setStatus(sessionStatusPassed);
    myLog("After setting session status.   Probable no change in status from "+sessionStatus+" to "+sessionStatusPassed);
}
// This was old code from version 1.0 when waiting for email verification was a thing to worry about.

    // console.log("authenticated:"+authenticated);
    // if (sessionStatus===sessionStatusPassed){
    //   console.log("Session Status same as request to change.  Ignoring setSessionStatus.");
    //   return;
    // }
    // // console.log("Active breadcrumb on enter:"+peek(breadcrumbs).name);
    // if (sessionStatusPassed===sessionStatusStates.authenticated||
    //   sessionStatusPassed===sessionStatusStates.authenticatedBySignon||
    //   sessionStatusPassed===sessionStatusStates.authenticatedByStateChange){
    //   console.log("Session Status Checkpoint 1.0 ",oym);
    //   authenticated=true;  // needs to be on for calls to resetting breadcrumbs //  Should only be set at one place at beginning of render (session status).  The setting of sessionState at the end of this method should cause a new render.
    //   // oym=privateOYM;
    //   // oym.loadData(doneLoading);
    //   console.log("Session Status Checkpoint 4.0 authentiated and load requested",oym);
       
    //   /*  When authorization occurs after signon, or email verification we 
    //       reset to "Home".  This will mean that if the user happens to be browsing
    //       in an authorizated state when authorization occurs, they will be interrupted
    //       and returned to home.  Unfortuately, this has to be done because we
    //       want to clear out breadcrumbs with their authorization states.  We cannot
    //       change authorization in the breadcrumbs since they are immutable.

    //       Another reason to authorize is when a signon is noticed by onAuthStateChanged.
    //       This will often be redundant to authenticatedBySignon.  It is important
    //       since it will be fired with a returning user with Session persistance set to local.
    //   */
    //   if (sessionStatusPassed===sessionStatusStates.authenticatedBySignon||
    //       sessionStatusPassed==sessionStatusStates.authenticatedByStateChange||
    //       sessionStatus===sessionStatusStates.waitingEmailVerification||
    //       sessionStatus===sessionStatusStates.waitingEmailVerification2) {
    //     resetBreadcrumbsToOhioYearlyMeeting();
    //     sessionStatusPassed=sessionStatusStates.authenticated;
    //   }
    // } else {
    //   console.log("Session Status Checkpoint 5.0 ",oym);
    //   authenticated=false;
    //   if (sessionStatusPassed===sessionStatusStates.notAuthenticated){
    //     console.log("Session Status Checkpoint 6.0 ",oym);
    //     user=null;
    //     resetBreadcrumbsToSignon();
    //     console.log("Session Status Checkpoint 7.0 ",oym);
    //   }
    // }
    // if (sessionStatusPassed===sessionStatusStates.waitingEmailVerification&&peek(breadcrumbs).name=="Signon"){
    //   resetBreadcrumbsToOhioYearlyMeeting();
    // }
    // console.log("Session Status Checkpoint 8.0 authenticated now:"+authenticated,oym);
    // console.log("Session Status Checkpoint 9.0 ",oym);
    // console.log("Active breadcrumb on exit:"+peek(breadcrumbs).name);
    // console.log("authenticated now:"+authenticated);
    // setStatus(sessionStatusPassed);
    // console.log("Session Status Checkpoint 10.0 ",oym);
  // }
  console.log("Checkpoint #8",user);
  
  /* useEffect once was neccessary to reload user so that we can see if the email has been verified.
     The switch between waitingEmailVerification and waitingEmailVerification2 is just to
     remind the user that the email needs to be verified.

     This is no longer the case.  Now it is used to load oym data since reading data in react 
     has side effects.
  */
  useEffect(()=> {
    myLog("Start executing inside useffect. Authenticated:"+authenticated);
    if (publicOYM.data==null){
      publicOYM.loadData(doneLoading);
    }
    if (sessionStatus===sessionStatusStates.authenticated&&privateOYM.data==null){
      privateOYM.loadData(doneLoading);
    }

    // if (oym.data==null){  // data not yet loaded.
    //   console.log("No data has been loaded yet.  isDataPrivate:"+oym.isDataPrivate);
    //   if (authenticated){  // if authenticated we should load private data.
    //     console.log("User has authenticated.  Will load private data");
    //     oym.setDataPrivate(true);   
    //   }
    //   console.log("About to request data load.  isDataPrivate:"+oym.isDataPrivate);
    //   oym.loadData(doneLoading);
    //   console.log("Data load has been requested.  isDataPrivate:"+oym.isDataPrivate);
    // } else { // data has already been loaded.
    //   console.log("Data was previously loaded.  isDataPrivate:"+oym.isDataPrivate);
    //   if (authenticated&&!oym.isDataPrivate){ // this only would occur if public loading completed before authentication.
    //     console.log("Will overlay public data with private  isDataPrivate:"+oym.isDataPrivate);
    //     oym.setDataPrivate(true);
    //     oym.loadData(doneLoading);
    //   }
    // }
    // if (authenticated&&privateOYM.data==null);{
    //   privateOYM.loadData(doneLoading);
    // }
    // let timeoutRef=setTimeout(refreshWaitCheck, 3000);
    // function refreshWaitCheck(status){
    //   console.log("function defined refreshWaitCheck",sessionStatus);
    //   if (user!==null){
    //     console.log("reloading user",user);
    //     user.reload();
    //   } else {
    //     console.log("cant reload user");
    //   }
    //   setSessionStatus(toggleWaitingForEmailVerification(sessionStatus));
    //   // if (sessionStatus===sessionStatusStates.waitingEmailVerification||sessionStatus===sessionStatusStates.waitingEmailVerification2){
    //   //   if (sessionStatus===sessionStatusStates.waitingEmailVerification){
    //   //     setSessionStatus(sessionStatusStates.waitingEmailVerification2)
    //   //   }else{
    //   //     setSessionStatus(sessionStatusStates.waitingEmailVerification)
    //   //   }
    //   // }
    // }
    // if (authenticated&&peek(breadcrumbs).name==="Signon"){
    //   console.log("found authentacted user with signon");
    //     resetBreadcrumbsToOhioYearlyMeeting();
    // }
    --AppMethodInvocation;
    myLog("End executing inside useffect. Authenticated:"+authenticated+" root breadcrumb:"+peek(breadcrumbs).name);
    // return function cleanup(){
    //   console.log("This would be cleaningup inside useeffect");
    //   clearTimeout(timeoutRef);
    // }
  });
  onAuthStateChanged(auth, (userChanged) => {
    myLog("Start onAuthStateChanged 1");
    console.log("Start onAuthStateChanged 2",auth.currentUser,user,userChanged);
    if (userChanged){
      console.log("New User available through onAuthStateChanged:",userChanged);
      if (user===null){
        user=userChanged;
        console.log("User set to new user available through onAuthStateChanged:",userChanged);
        if (user.emailVerified){
          setSessionStatus(sessionStatusStates.authenticatedByStateChange);
        } else {
          console.log("Illogic condition.  User not email verified.",user);
          // setSessionStatus(toggleWaitingForEmailVerification(sessionStatus));
        }
      }
    } else {
      console.log("User not available in onAuthStateChanged",auth.currentUser,user,userChanged);
    }
    console.log("End onAuthStateChanged 1",auth.currentUser,user,userChanged);
    myLog("End onAuthStateChanged 2",auth.currentUser,user,userChanged);
  });
  function submitSignout(e){
    myLog("signing out Checkpoint 1.0. "+oym.fileToLoad);
    signOut(auth).then(() => {
      console.log("Signing out Checkpoint 2.0.",oym);
      oym=publicOYM;
      setSessionStatus(sessionStatusStates.signoutCompleted);
    }).catch((error) => {
      console.log("An error occured while attempting to signout:"+error.message);
      alert("An error occured while attempting to signout:"+error.message);
    });
  } 
  let homePageButton=(<><button onClick={resetBreadcrumbsToOhioYearlyMeeting}>Home</button>&nbsp;&nbsp;&nbsp;</>);
  let friendPagedButton=(<></>);
  let friendListButton=(<></>);
  let meetingListButton=(<><button onClick={resetBreadcrumbsToMeetingList}>Monthly Meetings</button>&nbsp;&nbsp;&nbsp;</>);
  let committeeListButton=(<><button onClick={resetBreadcrumbsToCommitteeList}>Committees</button>&nbsp;&nbsp;&nbsp;</>);
  let mandOButton=(<><button onClick={resetBredcrumbsToMandO}>Ministry & Oversight</button>&nbsp;&nbsp;&nbsp;</>);
  let searchButton=(<></>);
  let passwordChangeButton=(<></>);
  let signOnOutButton=(<><br/></>); // sessionStatus waiting for authentication 
  if (!authenticated||sessionStatus===sessionStatusStates.notAuthenticated){
    signOnOutButton=(<><button onClick={resetBreadcrumbsToSignon}>Signon</button><br/></>)  
  } else if (sessionStatus===sessionStatusStates.authenticated){
    friendPagedButton=(<><button onClick={resetBreadcrumbsToFriendPaged}>Members List Paged</button>&nbsp;&nbsp;&nbsp;</>);
    friendListButton=(<><button onClick={resetBreadcrumbsToFriendList}>Members List</button>&nbsp;&nbsp;&nbsp;</>);
    passwordChangeButton=(<><button onClick={resetBreadcrumbsToPasswordChange}>Change Password</button><br/></>);
    searchButton=(<><button onClick={resetBreadcrumbsToSearch}>Search</button>&nbsp;&nbsp;&nbsp;</>);
    signOnOutButton=(<><button onClick={submitSignout}>Signout</button><br/></>)
  }

let sessionMessage="";
if (sessionStatus==sessionStatusStates.notAuthenticated|user===null){
    sessionMessage="Signon for access to more information.";
} else if (sessionStatus==sessionStatusStates.authenticated){
    sessionMessage="A Friend associated with "+user.email+" is currently signed on.";
    if (friendSignedOn!==null) {
      sessionMessage+="  According to our records, this email is owned by "+friendSignedOn.name+".";
    }
} else if (sessionStatus==sessionStatusStates.waitingEmailVerification||sessionStatus==sessionStatusStates.waitingEmailVerification2){
  sessionMessage=sessionStatus+ ".  Please see thy email in order to validate the use of this system.";
} else if (sessionStatus==sessionStatusStates.passwordChange){
  sessionMessage="An email has been sent to initialize or change your password.";
}

// End Session related.
myLog("Before Render.  Authenticated:"+authenticated);
console.log("Before Render.  Authenticated:"+authenticated,oym);

if (sessionStatus===sessionStatusStates.authenticated){
  // authenticated=true;
  oym=privateOYM;
} else {
  oym=publicOYM
}
console.log("oym is now",oym);
  if (oym.data==null){
      console.log("Rendering 'Please Wait'  message.",oym);
      return (<>Please wait while we load data.</>)
  } else {
    console.log("Rendering full home page.",oym.isDataPrivate,oym.data); 
    return (
 <> <div class="container">
     {console.log("Begin of Render.  Authenticated:"+authenticated)}
     {}
      <section id="menu">
        {homePageButton}
        {friendPagedButton}
        {friendListButton}
        {meetingListButton}
        {committeeListButton}
        {mandOButton}
        {searchButton}
        {/* <button onClick={resetBreadcrumbsToOhioYearlyMeeting}>Home</button>&nbsp;&nbsp;&nbsp;
        <button onClick={resetBreadcrumbsToFriendPaged}>Members List Paged</button>&nbsp;&nbsp;&nbsp;
        <button onClick={resetBreadcrumbsToFriendList}>Members List</button>&nbsp;&nbsp;&nbsp;
        <button onClick={resetBreadcrumbsToMeetingList}>Monthly Meetings</button>&nbsp;&nbsp;&nbsp;
        <button onClick={resetBreadcrumbsToCommitteeList}>Committees</button>&nbsp;&nbsp;&nbsp; */}
        {passwordChangeButton}
        {signOnOutButton}
      </section>
      {console.log("breadcrumbs before component:",breadcrumbs)}
      {/* {console.log("first breadcrumb before component:",breadcrumbs[0])}
      {console.log("Compare to friends array ",oym.data.friends[1])} */}
      <section id="breadcrumb">
        <BreadcrumbIndexList list={breadcrumbs} pickupBreadcrumbs={pickupBreadcrumbs} />
      </section>
      {/* {testmap(breadcrumbs)} */}
      {console.log("breadcrumbs:",breadcrumbs)}
      {/* {console.log("Peek breadcrumbs before rendering:"+breadcrumbs.length,peek(breadcrumbs))}
      {console.log("Type peeked:"+peek(breadcrumbs).type.name)} */} 
      <div id="windowx">
         {/* {sessionStatus}<br/> */}
         {console.log("before rendering crumb",peek(breadcrumbs),searchItem)}
         {peek(breadcrumbs).component}
         {console.log("after rendering crumb",peek(breadcrumbs),searchItem)}
      </div>
      <div id="status">
        {sessionMessage}
        <div id="version" onClick={displayVerion}>
          V
        </div>
      </div>

      {myLog("End of Render.  Authenticated:"+authenticated)}
    </div>
  </>
  )}
}

export default App;
